<template>
  <div>
    <h1 class="title">QUANTO È NUMEROSO IL TUO BRANCO?</h1>

    <div class="subtitle">
      Completa ora il quiz!
      <span v-if="showCouponCode">
        Per te
        <strong>{{ wizardData.couponDiscountDefault }}% di sconto</strong> con il
        <strong>codice: {{ wizardData.couponCodeDefault }}</strong>
      </span>
    </div>

    <form class="form max-w-xs mx-auto" @submit.prevent>
      <div class="form-group">
        <label class="form-label important-label" for="number_of_dogs">
          Quanti cani hai?
        </label>
        <input
          v-model.number="$v.form.numberOfDogs.$model"
          type="number"
          @blur="checkNumberOfDogs"
          placeholder="Digita il numero"
          step="1"
          min="1"
          max="9"
          class="form-control"
          id="number_of_dogs"
        />
        <div v-if="!$v.form.numberOfDogs.numeric" class="error">
          si prega di indicare un numero intero
        </div>
        <div v-else-if="$v.form.numberOfDogs.$error" class="error">
          campo obbligatorio
        </div>
      </div>

      <div v-if="showInputSameDiet" class="form-group">
        <label class="form-label important-label">
          Vuoi una ricetta uguale per tutti i tuoi cani?
        </label>
        <div class="switch-container">
          <label
            for="same_diet_yes"
            class="switch-option"
            :class="[form.sameDiet ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.form.sameDiet.$model"
              class="hidden"
              type="radio"
              id="same_diet_yes"
              value="1"
            />
            <span>Sì</span>
          </label>
          <label
            for="same_diet_no"
            class="switch-option"
            :class="[!form.sameDiet ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.form.sameDiet.$model"
              class="hidden"
              type="radio"
              id="same_diet_no"
              value="0"
            />
            <span>No</span>
          </label>
        </div>
        <div v-if="$v.form.sameDiet.$error" class="error">campo obbligatorio</div>
        <div v-if="form.sameDiet" class="additional-info">
          <strong>Potrai risparmiare fino al 50%.</strong><br />Il gusto sarà uguale per
          tutti ma varierà comunque il quantitativo in base alle caratteristiche di
          ognuno. Protrai in ogni momento aggiungere nuovi abbonamenti o fare variazioni.
        </div>
        <div v-if="!form.sameDiet" class="additional-info">
          Ogni cane avrà la massima personalizzazione della propria pappa.
        </div>

        <div class="additional-info pt-6">
          <strong>N.B.</strong><br />Ora ti chiederemo le informazioni dei tuoi cani, uno
          alla volta.
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {
  required,
  minValue,
  maxValue,
  numeric,
  requiredIf,
} from "vuelidate/lib/validators";

export default {
  props: {
    wizardData: {
      type: Object,
      required: true,
    },
    dogData: {
      type: Object,
      required: true,
    },
    listData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: {
        numberOfDogs: this.wizardData.numberOfDogs,
        sameDiet: 1,
      },
    };
  },
  validations: {
    form: {
      numberOfDogs: {
        required,
        numeric,
        minValue: minValue(1),
        maxValue: maxValue(9),
      },
      sameDiet: {
        required: requiredIf(function () {
          return this.showInputSameDiet;
        }),
      },
    },
  },
  computed: {
    showInputSameDiet: function () {
      return this.form.numberOfDogs > 1;
    },
    showCouponCode() {
      return this.wizardData.couponCodeDefault != "";
    },
  },
  watch: {
    "form.numberOfDogs": function (after) {
      if (after == 1) this.form.sameDiet = 1;
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
      return new Promise((resolve, reject) => {
        if (!this.$v.$invalid) {
          resolve({
            form: {
              numberOfDogs: this.form.numberOfDogs,
              sameDiet: this.form.sameDiet,
            },
          });
        } else {
          reject("invalid entry");
        }
      });
    },
    checkNumberOfDogs(event) {
      // automatically change number of dogs
      // if is lower or greater than minimum or maximum.
      var value = event.target.value;
      if (parseInt(value) > 9) {
        this.form.numberOfDogs = 9;
      } else if (parseInt(value) < 1) {
        this.form.numberOfDogs = 1;
      }
    },
  },
  activated() {
    this.$v.$reset();
  },
};
</script>
